import * as React from 'react';
import Badge, { BadgeProps } from '@material-ui/core/Badge';

export type DSBadgeProps = BadgeProps;

export const DSBadge: React.FC<DSBadgeProps> = props => <Badge {...props} />;
